import _asyncToGenerator from "E:/code/nkyOrder/trunk/vantCommon/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
import { wechatConfig } from "@/api/module/auth";
import wx from "weixin-js-sdk"; // 工具类

export default {
  data: function data() {
    return {
      isWechat: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var that, ua, isWeixin, params;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              that = _this;
              ua = navigator.userAgent.toLowerCase(); //判断是否是微信浏览器

              isWeixin = ua.indexOf("micromessenger") != -1; //判断是否

              if (isWeixin) {
                _context.next = 8;
                break;
              }

              Toast("请在微信浏览器中打开");
              _this.isWechat = false;
              return _context.abrupt("return", false);

            case 8:
              if (isWeixin) {
                _this.isWechat = true;
                params = {
                  url: location.href.split('#')[0]
                };
                wechatConfig(params).then(function (res) {
                  if (res.code == 200) {
                    wx.config({
                      debug: true,
                      // 开启调试模式,
                      appId: res.data.appId,
                      // 必填，企业号的唯一标识，此处填写企业号corpid
                      timestamp: res.data.timestamp,
                      // 必填，生成签名的时间戳
                      nonceStr: res.data.nonceStr,
                      // 必填，生成签名的随机串
                      signature: res.data.signature,
                      // 必填，签名，见附录1
                      jsApiList: ["scanQRCode", "updateAppMessageShareData", "updateTimelineShareData"],
                      // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                      openTagList: ["wx-open-launch-weapp"]
                    });
                    wx.ready(function () {
                      console.log("---------ready---------");
                    });
                    wx.error(function (res) {
                      console.log("--------fail--------", res);
                    });
                  }
                });
              }

              _context.next = 13;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](0);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 11]]);
    }))();
  },
  methods: {
    launch: function launch(e) {
      console.log("获取小程序 允许 按钮 操作回调", e);
    }
  }
};